import Vue from 'vue';

export default function notification(text: string, type: string) {
    if (text != null && text.includes('TypeError: Cannot read properties of undefined')) {
        text = 'Seu tempo de sessão expirou! Por favor, realize a autenticação novamente.';
    }
    Vue.prototype.$notify.toast(text, { color: type });
}
